import React from 'react';
import { useNavigate } from 'react-router-dom';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import { Button, Grid } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { primaryButtonBackground } from '../../constants/Colors';
import { screenType } from '../../constants/enum';

const styles = {
  EditOutlinedIconStyle: {
    height: '50px',
    width: '50px'
  },
  EditOutlinedIconStyleCenter: {
    marginBottom: '24px',
    textAlign: 'center'
  },
  button: {
    '@media screen and (max-width:960px)': {
      height: '42px'
    },
    height: '42px',
    width: '400px'
  },
  cardContent: {
    ':last-child': {
      pb: '45px'
    },
    '@media screen and (max-width:960px)': {
      padding: '30px 0'
    },
    padding: '45px'
  },
  detailStyle: {
    '@media screen and (max-width:960px)': {
      fontSize: '14px',
      marginBottom: '20px'
    },
    color: '#222222',
    fontSize: '16px',
    fontWeight: '400',
    textAlign: 'center'
  },
  nothingGivenListSize: {
    '@media screen and (max-width:960px)': {
      margin: '16px'
    },
    borderRadius: '0px',
    boxShadow: '0',
    boxSizing: 'border-box',
    margin: '24px',
    padding: '16px',
    width: 'auto'
  },
  primaryButtonBackground,
  titleStyle: {
    color: '#222222',
    fontSize: '22px',
    fontWeight: '500',
    textAlign: 'center'
  }
};

interface NothingGivenListType {
  title: string;
  detail: string;
  type?: string;
  screen?: number;
}

const NothingGivenList: React.FC<NothingGivenListType> = (
  props: NothingGivenListType
) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Card sx={styles.nothingGivenListSize}>
        <CardContent sx={styles.cardContent}>
          <Typography sx={styles.EditOutlinedIconStyleCenter}>
            {props.type === 'mediaFavorite' ? (
              <StarBorderRoundedIcon sx={styles.EditOutlinedIconStyle} />
            ) : (
              <EditOutlinedIcon sx={styles.EditOutlinedIconStyle} />
            )}
          </Typography>
          <Typography sx={styles.titleStyle}>{props.title}</Typography>
          <br />
          <Typography sx={styles.detailStyle}>
            {props.detail.split('\n').map((str, index) => (
              <React.Fragment key={index}>
                {str}
                <br />
              </React.Fragment>
            ))}
          </Typography>
          {props.type === 'mediaFavorite' && (
            <Grid container justifyContent={'center'} sx={{ mt: '80px' }}>
              <Button
                sx={[styles.primaryButtonBackground, styles.button]}
                onClick={() => {
                  if (props.screen === screenType.client) {
                    navigate('/client/mypage/media/');
                  } else if (props.screen === screenType.agent) {
                    navigate('/agent/mypage/media/');
                  }
                }}
              >
                <Typography color={'white'}>
                  {t('media.searchMedia')}
                </Typography>
              </Button>
            </Grid>
          )}
          {props.type === 'issueFavorite' && (
            <Grid container justifyContent={'center'} sx={{ mt: '80px' }}>
              <Button
                sx={[styles.primaryButtonBackground, styles.button]}
                onClick={() => {
                  navigate('/publisher/mypage/issue/');
                }}
              >
                <Typography color={'white'}>
                  {t('issueFavoLike.searchIssue')}
                </Typography>
              </Button>
            </Grid>
          )}
        </CardContent>
      </Card>
    </>
  );
};

export default NothingGivenList;
